
import axios from 'axios';
import toast from '../../utils/ToasterService';

import apiAddress from './apiAddress';

const apiClient = axios.create({
  baseURL: apiAddress,
  timeout: 5000,
  // headers: {'X-Custom-Header': 'foobar'}
});

export default apiClient;
 


/* 
const apiClient = axios.create({
  baseURL: apiAddress, // Set your API base URL here
  timeout: 5000, // Set a timeout for requests (optional)
}); */


export const sendRequest = (method, endpoint, data = null) => {
  return apiClient[method](endpoint, data)
    .then(response => response.data)
    .catch(error => {

      throw new Error(`API Error: ${error.message}`);
    });
};

export const pingURL ="/"



/* module.exports = {
  apiClient,
  sendRequest,
}; */

/* export default apiClient; */